import { render, staticRenderFns } from "./SpecificationDetail.vue?vue&type=template&id=35898bba"
import script from "./SpecificationDetail.vue?vue&type=script&lang=js"
export * from "./SpecificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports